export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <header className="border-b border-background-200">
        <div className="container-page flex h-16 items-center md:h-[72px]">
          <a href="/" className="flex items-center gap-2.5">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-600 font-heading text-xl font-black text-background-50">瓜</span>
            <span className="font-heading text-lg font-bold tracking-tight text-foreground-950">快手吃瓜</span>
          </a>
        </div>
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-20">
        <div className="flex max-w-xl flex-col items-center text-center">
          <span className="font-heading text-7xl font-black text-primary-600 md:text-8xl">404</span>
          <p className="mt-3 text-lg font-bold text-foreground-950">这块瓜田走丢了</p>
          <p className="mt-2 text-sm text-foreground-600">你访问的页面不存在或已被重新整理，回到首页热榜看看大家在聊什么吧。</p>
          <div className="mt-7 flex flex-wrap justify-center gap-3">
            <a href="/" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-600 px-6 py-3 text-sm font-semibold text-background-50 hover:bg-primary-700">
              <i className="ri-home-4-line" aria-hidden="true" />回到首页
            </a>
            <a href="/#hot" className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-300 px-6 py-3 text-sm font-semibold text-foreground-800 hover:border-primary-300 hover:text-primary-700">
              看今日热榜
            </a>
          </div>
        </div>
      </main>
    </div>
  );
}